var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg085Disabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M466,437h-34v-92c0-33.084-26.916-60-60-60h-72.905c-11.021,0-19.993-8.967-20-19.988l-0.086-148.807 C301.762,107.672,318,85.697,318,60c0-33.084-26.916-60-60-60s-60,26.916-60,60c0,23.601,13.698,44.063,33.561,53.854 l-65.268,53.701C161.676,171.354,159,177.021,159,183v94c0,11.046,8.954,20,20,20s20-8.954,20-20v-84.556l40.033-32.939 l0.062,105.53c0.019,33.064,26.935,59.965,60,59.965H372c11.028,0,20,8.972,20,20v112c0,11.046,8.954,20,20,20h54 c11.046,0,20-8.954,20-20C486,445.954,477.046,437,466,437z M258,80c-11.028,0-20-8.972-20-20s8.972-20,20-20s20,8.972,20,20 S269.028,80,258,80z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,472c-66.72,0-121-54.28-121-121c0-41.527,21.032-78.227,53-100.024v-45.892C64.115,230.762,26,286.511,26,351 c0,88.775,72.225,161,161,161c84.058,0,153.266-64.756,160.385-147h-40.199C300.223,425.148,248.984,472,187,472z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg085Disabled);
export default __webpack_public_path__ + "static/media/085-disabled.9f48549b86545c0aa8bcca3feed98aad.svg";
export { ForwardRef as ReactComponent };